module.exports = __webpack_public_path__ + "img/m-jian-z-4-0.9d363af6.png";